export enum ApplicationStatus {
  MemberRegistrationModule_Draft = 1,
  MemberRegistrationModule_PendingWithHRHOD = 2,
  MemberRegistrationModule_RejectedHRHOD = 3,
  MemberRegistrationModule_PendingWithMemberForPaymentDetails = 4,
  MemberRegistrationModule_PendingWithInternalTeam = 5,
  MemberRegistrationModule_RejectedByInternalTeam = 6,
  // MemberRegistrationModule_PendingWithAdmin = 5,
  // MemberRegistrationModule_RejectedByAdmin = 6,
  MemberRegistrationModule_PendingWithEnrollmentCommittee = 7,
  MemberRegistrationModule_MemberRequestApproved = 8,
  MemberRegistrationModule_MemberRequestRejected = 9,
  MemberRegistrationModule_MemberIDCreationCompleted = 31,
}
// Sanjeevani Deposit
export enum SanjeevaniDepositStatus {
  Deposit_Approval_Pending = 72, //Member
  FD_Number_genrator_pending = 73, //Admin approve
  Deposit_Approved = 74, // sap
  Deposit_Rejected = 75, // Admin Reject
}
// Sanjeevani Withdraw
export enum SanjeevaniWithdrawStatus {
  FD_Withdraw_Approval_pending = 76, //
  FD_Withdraw_Number_genrator_pending = 77, //Admin approve
  FD_Withdraw_Number = 78, //
  FD_Withdraw_Rejected = 79, // Admin Reject
  FD_Withdraw_Approved = 80,
}

// Suvidha Deposit
export enum SuvidhaDepositStatus {
  SU_Deposit_Approval_pending = 126,
  SU_FD_Number_genrator_pending = 127,
  SU_Deposit_Approved = 128,
  SU_Deposit_Rejected = 129,
}

// Suvidha Withdraw
export enum SuvidhaWithdrawStatus {
  SU_FD_Withdraw_Approval_pending = 130,
  SU_FD_Withdraw_Number_genrator_pending = 131,
  SU_FD_Withdraw_Rejected = 132,
  SU_FD_Withdraw_Approved = 133,
}

export enum LoanStatus {
  LoanModule_Draft = 51, //	Loan Draft
  LoanModule_SuretyApprovalPending = 52, //	Member has submitted surety details

  // For Loan surety Table
  LoanModule_SuretyAcceptedByMember = 53, //  member has Approved Surety
  LoanModule_SuretyRejectedByMember = 54, //  member has Rejected Surety

  LoanModule_InvalidSuretyLink = 54.5, //  if surety approval link is invalid, DO NOT STORE IN BACKEND
  // For Loan surety Table
  LoanModule_AllSuretyApproved = 55, //  Surety approved by all SuretyMember

  LoanModule_PendingWithInternalTeam = 56, //	apply for loan -> pending with internal team
  LoanModule_PendingMemberLoanConfirmation = 57, //	Accepted By internal team -> Pending member loan confirmation -->> by Member
  LoanModule_RejectedByInternalTeam = 58, //	Rejected by internal team
  LoanModule_LoanAgreementPending = 59, //	sending *Loan agreement pending* to member

  LoanModule_LoanApplicationCancelledByMember = 60, //	Member clicked no on loan application screen
  // not for short term
  LoanModule_MemberSignaturePending = 61, //	Member Signature pending
  LoanModule_MemberSignatureVerificationPendingByInternalTeam = 62, //	Loan Committee ->> Member Signature verifation pending
  LoanModule_MemberSignatureVerificationRejected = 63, //	Member Signature verifation rejected
  // not for short term

  LoanModule_LoanCommitteeApprovalPending = 64, //	Loan committee approval pending
  LoanModule_MemberAgreementRejected = 65, //	Member agreement rejected

  // loan commitee 1
  LoanModule_LoanFinalApprovalPending = 66, //	final loan approval pending
  LoanModule_LoanApplicationRejected = 67, //	Loan application rejected

  // loan commitee 2
  LoanModule_DocumentGenerationPending = 68, //	Loan document generated
  LoanModule_LoanApplicationApproved = 69, //	Loan application approved after generated

  LoanModule_LoanInprogress = 70, // If Loan Inprogress -> recovery API
  LoanModule_LoanCompleted = 71, // If Loan Completed -> recovery API

  LoanModule_PendingWithHrHOD = 153, // After surety approve ot goes to hr/hod and then team member
  LoanModule_RejectedByHrHOD = 154,
}

// Loan Module Flow 
// PD/BD/LD Save and Next - Draft

// Surety Details Proceed - Surety approval pending
// Surety Details  - approved by both the surety user - Change button label to submit - Pending with internal team

// internal team - Approve - Pending with member for loan confirmation
// internal team - Reject - Rejected by Internal team (resumit same loan) - Same flow

// Member (After internal team approval) 253 - Proceed Yes - Loan aggrement pending
// Member (After internal team approval) 253 - Proceed No - Loan application cancel by member

// Internal Team (Loan aggrement pending) - Submit - Member signature pending
// Member - Submit  - Member signature verification pending (with Internal Team)

// Internal Team - Approve - Member signature verification Approve -> loan commitee
// Internal Team - Reject - Member signature verification Rejected - > Member (Member signature pending)

// ***Flow required 2 loan commitee approval
// loan commitee 1- Approve - loan final approval pending
// loan commitee 1- Reject -  loan application Rejected (By 1)

// loan commitee 2- Approve - Document Number genrator pending
// loan commitee 2- Reject -  loan application Rejected (By 2)

// After loan appl approved then Document number api called and document no generated in SAP.
// After Document number we received from SAP then status - Loan appl approved

export enum LoanRepayment {
  LoanRepayment_MemberApplyForLoanRepayment = 101, // Member applies for loan repayment amount. On submission, the request is sent to the internal team for approval

  LoanRepayment_InternalTeamAcceptLoanRepayment = 102, // the request is sent to the member for payment details
  LoanRepayment_InternalTeamRejectLoanRepayment = 103, //editable-- the request is sent back to the member for corrections. Member will resubmit the request to the internal team with corrections.
  LoanRepayment_InternalTeamSendBackLoanRepayment = 104, //editable-- the request is sent back to the member for corrections. Member will resubmit the request to the internal team with corrections.

  LoanRepayment_MemberPaymentDetailsPending = 105, //Internal team approves amount - Payment details pending
  LoanRepayment_InternalTeamRepaymentDetailsApprovalPending = 106, //Internal team approves amount - Payment details pending

  LoanRepayment_InternalTeamPaymentDetailsRequestSentBack = 107, // Internal team sends back payment details - Payment details request sent back
  LoanRepayment_InternalTeamPaymentDetailsRequestReject = 108, // Internal team rejects amount/payment - repayment request rejected
  LoanRepayment_InternalTeamPaymentDetailsRequestAccept = 109, // Internal team rejects amount/payment - repayment request rejected

  LoanRepayment_PaymentDetailsRequestCancel = 110, // reject from utility
}

// Member submits repayment request - Amount approval pending
// Internal team sends back approval amount - Amount request sent back
// Internal team approves amount - Payment details pending
// Member submits repayment request - Repayment details approval pending
// Internal team approves payment details - Payment details approved
// Internal team sends back payment details - Payment details request sent back
// Internal team rejects amount/payment - repayment request rejected

// LoanRepayment_InternalTeamAcceptLoanRepayment
// LoanRepayment_InternalTeamRejectLoanRepayment
// LoanRepayment_InternalTeamSendBackLoanRepayment
// LoanRepayment_MemberPaymentDetailsPending
// LoanRepayment_InternalTeamRepaymentDetailsApprovalPending
// LoanRepayment_InternalTeamPaymentDetailsRequestSentBack
// LoanRepayment_InternalTeamPaymentDetailsRequestReject
// LoanRepayment_InternalTeamPaymentDetailsRequestAccept
export enum SettlementReqStatus {
  Settlement_Approval_Pending = 135,
  Settlement_Approved = 136,
  Settlement_Approved2 = 139,
  Settlement_Rejected = 137,
  Settlement_Data_Pending = 138,
  FinalSettlementApprovalPending = 152,
}
// approval pending -> http://localhost:3000/SettlementRequestTabs -> internal team
// approval pending -> http://localhost:3000/FinalSettlement -> member (view only)
// =====
// approval -> http://localhost:3000/FinalSettlement -> member (view only)
// reject -> http://localhost:3000/FinalSettlement -> member (view only) re apply 
// =====
// approve - reject -> http://localhost:3000/SettlementRequestTabs -> view only
